import { render, staticRenderFns } from "./PurchaseLicenseDatabaseItem.vue?vue&type=template&id=0d05d8d2&scoped=true&"
import script from "./PurchaseLicenseDatabaseItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseLicenseDatabaseItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseLicenseDatabaseItem.vue?vue&type=style&index=0&id=0d05d8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d05d8d2",
  null
  
)

export default component.exports